















import Vue from "vue";

export default Vue.extend({
  name: "LoadMore",
  props: {
    shown: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  computed: {
    hasMore(): boolean {
      return this.shown < this.total;
    },
    remaining(): number {
      return Math.max(this.total - this.shown, 0);
    }
  }
});
